import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { normalizeLang } from '@/utils/approval/i18nText';
import { DOCUMENT_STATUS_CONFIG, pickLang } from './statusMapping';
import {
  FormInlineLabel,
  StatusChipPink,
  StatusFormRow,
} from './styles';
import type { ApprovalViewType, DocumentStatus } from './types';

/**
 * 제목 위 한 줄: 좌측 상태 chip("결재 진행중 입니다.") + 우측 "양식: {type.name}".
 */

type StatusFormLabelsProps = {
  status: DocumentStatus;
  type: ApprovalViewType;
};

// 상태별 문장 라벨 — 기본품의(type 1) 기준. 다른 유형에서 재정의 필요 시 props override.
const STATUS_SENTENCE: Record<DocumentStatus, string> = {
  S: '임시저장 입니다.',
  P: '결재 진행중 입니다.',
  H: '결재 보류중 입니다.',
  C: '결재 완료 입니다.',
  D: '삭제 되었습니다.',
  R: '결재 반려 되었습니다.',
  X: '취소 되었습니다.',
};

const StatusFormLabels = ({ status, type }: StatusFormLabelsProps) => {
  const { t, i18n } = useTranslation();
  const lang = useMemo(() => normalizeLang(i18n.language), [i18n.language]);

  const tone = DOCUMENT_STATUS_CONFIG[status]?.tone ?? 'neutral';

  const sentence = STATUS_SENTENCE[status] ?? '';
  const formName = pickLang(type.name, lang);

  return (
    <StatusFormRow>
      <StatusChipPink tone={tone}>{sentence ? t(sentence) : status}</StatusChipPink>
      {formName && (
        <FormInlineLabel>
          {t('양식')}: {formName}
        </FormInlineLabel>
      )}
    </StatusFormRow>
  );
};

export default StatusFormLabels;
